import type { ReactNode } from 'react';
import { Group } from '@mantine/core';

import styles from './FormFooter.module.css';

interface FormFooterProps {
  leftActions?: ReactNode;
  rightActions: ReactNode;
  className?: string;
}

export function FormFooter({
  leftActions,
  rightActions,
  className,
}: FormFooterProps) {
  const rootClassName = className
    ? `${styles.footer} ${className}`
    : styles.footer;

  return (
    <Group
      justify={leftActions ? 'space-between' : 'flex-end'}
      wrap="nowrap"
      className={rootClassName}
    >
      {leftActions}
      {rightActions}
    </Group>
  );
}
